import { DateTime } from 'luxon';
import { TimeFormatOptions } from './bzDateTime';

export const getTimeDisplayFormat = (options: TimeFormatOptions) => {
  const { includeZero, timeFormat = '24-hour', withoutSeconds, withoutSpace } = options ?? {};
  let hours = timeFormat === '24-hour' ? 'H' : 'h';
  if (includeZero) {
    hours += hours;
  }
  const space = withoutSpace || timeFormat === '24-hour' ? '' : ' ';
  const ss = withoutSeconds ? '' : ':ss';
  const formatSuffix = timeFormat === '24-hour' ? '' : 'a';
  return `${hours}:mm${ss}${space}${formatSuffix}`;
};

export const parseDateTime = (dateTime: Date | string) =>
  typeof dateTime === 'string'
    ? DateTime.fromFormat(dateTime?.replace(' UTC', ''), 'yyyy-MM-dd HH:mm').toJSDate()
    : dateTime;

export const formatDateTime = (dateTime: Date | string) => {
  const date = formatDate(dateTime);
  const time = formatTime(dateTime);
  return `${date}, ${time}`;
};

export const formatDate = (dateTime: Date | string, seperator = '/') => {
  const date = parseDateTime(dateTime);
  const year = date.getFullYear().toString().substr(-2);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${month}${seperator}${day}${seperator}${year}`;
};

export const formatTime = (dateTime: Date | string) => {
  const date = parseDateTime(dateTime);
  let hours = date.getHours();
  let minutes = date.getMinutes().toString();
  const suffix = hours >= 12 ? 'PM' : 'AM';

  hours %= 12;
  hours = hours || 12;
  minutes = minutes.padStart(2, '0');

  return `${hours}:${minutes} ${suffix}`;
};

interface TimePeriod {
  month?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow' | undefined;
  day?: 'numeric' | '2-digit' | undefined;
  year?: 'numeric' | '2-digit' | undefined;
}

export const formatDatePretty = (
  dateString: string,
  options?: { emitYear?: boolean; emitCurrentYear?: boolean; timePeriod?: TimePeriod },
) => {
  const date = DateTime.fromISO(dateString);
  const month = date.toLocaleString({ month: options?.timePeriod?.month || 'long' });
  const day = date.toLocaleString({ day: options?.timePeriod?.day || 'numeric' });
  const year = date.toLocaleString({ year: options?.timePeriod?.year || 'numeric' });

  if (options?.emitYear) {
    return `${month} ${day}`;
  }

  if (options?.emitCurrentYear && year === DateTime.now().year.toString()) {
    return `${month} ${day}`;
  }

  return `${month} ${day}, ${year}`;
};

export const formatDurationPretty = (duration: number) => {
  const hrs = Math.floor(duration / 3600);
  const mins = Math.floor((duration % 3600) / 60);
  const secs = Math.floor(duration % 60);

  let formattedTime = '';

  if (hrs > 0) {
    formattedTime += `${hrs}:${mins < 10 ? '0' : ''}`;
  }

  formattedTime += `${mins}:${secs < 10 ? '0' : ''}`;
  formattedTime += `${secs}`;
  return formattedTime;
};
